import client from './client'

async function statistics ({ serviceID }) {
  const response = await client.get(`/services/${serviceID}/statistics`)
  return response.data
}

async function getDevices ({ serviceID, status }) {
  const response = await client.get('/devices', {
    params: {
      serviceID,
      status
    }
  })
  return { devices: response.data }
}

export default {
  statistics,
  getDevices
}
